"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarousel: function() {
        return _index.TeachingPopoverCarousel;
    },
    renderTeachingPopoverCarousel_unstable: function() {
        return _index.renderTeachingPopoverCarousel_unstable;
    },
    teachingPopoverCarouselClassNames: function() {
        return _index.teachingPopoverCarouselClassNames;
    },
    useTeachingPopoverCarouselContextValues_unstable: function() {
        return _index.useTeachingPopoverCarouselContextValues_unstable;
    },
    useTeachingPopoverCarouselStyles_unstable: function() {
        return _index.useTeachingPopoverCarouselStyles_unstable;
    },
    useTeachingPopoverCarousel_unstable: function() {
        return _index.useTeachingPopoverCarousel_unstable;
    }
});
const _index = require("./components/TeachingPopoverCarousel/index");
